import { render, staticRenderFns } from "./noticeAnnouncement.vue?vue&type=template&id=d6b1dd08&"
import script from "./noticeAnnouncement.vue?vue&type=script&lang=js&"
export * from "./noticeAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/ctrl/announcemenMail/noticeAnnouncement.vue"
export default component.exports